import { Component, OnInit } from '@angular/core';
import { Config, Success } from '../../models/config.model';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-success',
  template: `
    <div class="success-container">
      <div class="h3 message">{{ config.success.title }}</div>
      <div class="h4 message" *ngIf="config.success.message">{{ config.success.message }}</div>
      <div class="checkmark-container">
        <div class="checkmark"></div>
      </div>
      <app-web-button *ngIf="returnURL" [id]="'checkout-return-to-calling-app'" [label]="config.success.button" [data]="config.success.button" [style]="'white'" (clicked)="onBack()"></app-web-button>
    </div>
  `,
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {
  constructor(
    private localStorageService: LocalStorageService,
    private sharedDataService: SharedDataService,
    private navigationService: NavigationService
  ) {}

  returnURL: string;
  config: Config;

  ngOnInit(): void {
    this.sharedDataService.getConfig().subscribe((config) => {
      this.config = config;
    });
    this.returnURL = this.sharedDataService.getReturnURL();
    this.localStorageService.clearData(); // clear all stored data after successful purchase
  }

  onBack(): void {
    this.navigationService.navigateBack();
  }
}
